const FORM_CONFIG = {
  id: 'request-a-representative-form',
  analytics: {
    category: 'Forms',
    action: 'RequestARepresentativeFormSubmission',
    trackEvents: ['submit', 'reset', 'error']
  },
  defaultValues: {
    firstName: '',
    middleName: '',
    lastName: '',
    email: '',
    credential: '',
    npiNumberCreds: '',
    specialty: '',
    phoneNumber: '',
    affairsFacility: '',
    facilitySearch: '',
    address: '',
    city: '',
    state: '',
    zipCode: '',
    optInFutureCommunications: false,
  },
  sections: {
    pi: {
      id: 'pi-section',
      title: 'Personal Information'
    },
    clinical: {
      id: 'clinical-section',
      title: 'Hospital/Practice/Clinic Information'
    }
  }
};


export default FORM_CONFIG; 